module.exports = __webpack_public_path__ + "static/media/food-chains-in-peril-tablet.ef785a40.jpg";